module.exports = __webpack_public_path__ + "static/media/gift.b43eec3b.svg";